import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 48 48",
  style: {"enable-background":"new 0 0 48 48"},
  "xml:space": "preserve",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"matrix(2,0,0,2,0,0)\"><circle cx=\"13.5\" cy=\"10.5\" r=\"4\" style=\"fill:#313131;\"></circle><path d=\"M17.5,10.5c0-0.7-0.2-1.4-0.5-2c-1.9-1.1-4.4-0.4-5.5,1.5c-0.7,1.2-0.7,2.7,0,4c1.9,1.1,4.4,0.4,5.5-1.5\n\t\tC17.3,11.9,17.5,11.2,17.5,10.5z\" style=\"fill:#FFCD32;\"></path><circle class=\"st2\" cx=\"2\" cy=\"5.5\" r=\"1.5\"></circle><circle class=\"st2\" cx=\"22\" cy=\"2\" r=\"1.5\"></circle><circle class=\"st2\" cx=\"2\" cy=\"22\" r=\"1.5\"></circle><circle class=\"st2\" cx=\"13.5\" cy=\"22\" r=\"1.5\"></circle><line class=\"st3\" x1=\"3.1\" y1=\"20.9\" x2=\"10.7\" y2=\"13.3\"></line><line class=\"st3\" x1=\"16.3\" y1=\"7.7\" x2=\"20.9\" y2=\"3.1\"></line><line class=\"st3\" x1=\"3.3\" y1=\"6.1\" x2=\"9.8\" y2=\"8.9\"></line><line class=\"st3\" x1=\"20.6\" y1=\"14\" x2=\"16.9\" y2=\"12.5\"></line><line class=\"st3\" x1=\"13.5\" y1=\"20.5\" x2=\"13.5\" y2=\"14.5\"></line><circle class=\"st2\" cx=\"22\" cy=\"14.5\" r=\"1.5\"></circle><circle class=\"st3\" cx=\"13.5\" cy=\"10.5\" r=\"4\"></circle></g>", 1)
  ])))
}
export default { render: render }